<template>
  <el-dialog title="高级搜索" :model-value="dialogVisible" width="700" :before-close="handleClose" @open="open">
    <el-form v-loading="loading" :model="postForm" ref="postForm" label-width="110px">
      <el-form-item label="关键词" prop="searchKey" class="form-inline-block formItem100">
        <el-input v-model="postForm.searchKey" placeholder="关键词"  @keydown.enter="searchChange()"></el-input>
      </el-form-item>
      <el-form-item label="时间" class="form-inline-block formItem50">
        <div style="display: flex;align-items: center;">
          <el-date-picker @keydown.enter="searchChange()" style="width: 200px;" :editable="true" v-model="postForm.startTime" type="datetime"
            format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
          <span style="padding: 0 10px;">至</span>
          <el-date-picker @keydown.enter="searchChange()" style="width: 200px;" :editable="true" v-model="postForm.endTime" type="datetime"
            format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="关键词位置" prop="searchType" class=" formItem100">
        <el-radio-group v-model="postForm.searchType">
          <el-radio value="01">全部位置</el-radio>
          <el-radio value="02">仅标题</el-radio>
          <el-radio value="03">仅内容 </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="附件搜索" prop="attachmentSearch" class="form-inline-block formItem100">
        <el-input  @keydown.enter="searchChange()" v-model="postForm.attachmentSearch"></el-input>
      </el-form-item>

    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="searchChange()">
          搜索
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'searchDialog',
  components: {
  },
  props: ['dialogVisible'],
  data() {
    return {
      postForm: {
        searchType: '01'
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    open() { },
    searchChange() {
      localStorage.setItem("searchData",JSON.stringify(this.postForm));
      this.$router.push({
        path: '/search',
        query: {
          searchKey: this.searchKey,
          searchType: 2,
          time:new Date().getTime()
        }
      })
      this.handleClose()
      this.$emit('clearCearch')
    },
    handleClose() {
      this.$emit('searchDialogClose')
    }
  }
}
</script>
<style lang="scss">
.formItem50 {
  width: 49%;
}

.formItem100 {
  width: 98%;
}
</style>
